import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { ApiKeyDto } from '../../../models/api-key/dto/api-key.dto';
import { GET_API_KEYS_QUERY_KEY } from './constants';

export const useRevokeApiKey = (organizationId: string) => {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (apiKeyId: string) =>
      client.fetchApi<ApiKeyDto, undefined>({
        endpoint: `organizations/${organizationId}/api-keys/${apiKeyId}/revoke`,
        method: 'POST',
      }),
    onSuccess: (revoked) => {
      // Flip the row status in cache rather than refetching.
      queryClient.setQueriesData<{ apiKeys: ApiKeyDto[] } | undefined>(
        { queryKey: GET_API_KEYS_QUERY_KEY(organizationId) },
        (old) => {
          if (!old) return old;
          return {
            apiKeys: old.apiKeys.map((k) =>
              k.id === revoked.id ? revoked : k,
            ),
          };
        },
      );
    },
  });
};
